import React from 'react';
import {Link} from 'react-router-dom';
import {Row, Col} from 'react-bootstrap';
import {trackEvent} from '../util/tracking';

function urlCheck(pathName, string){
  if (pathName.includes(string)){
    return 'on';
  } else{
    return '';
  }
}

export const ProNav = ({type, loc}) => {
  return(
    <div>
      <Row className={"title "+type}>
        <Col xs={12}>
          <span>{(type==='Coach'?'EDGE Coach':type)}</span>
        </Col>
      </Row>
      {type==="AI"?
        <Row className="pro_links">
          <Col xs={12}>
            <Link to="/premium/personal-training"
             className={"side "+urlCheck(loc, 'personal-training')}
             onClick={() => {trackEvent("PREMIUM-AI", "Tap Click - Personal Training", "")}}
            >
              Personal Training
            </Link>
            <Link to="/premium/wrong-notes"
             className={"center "+urlCheck(loc, 'wrong-notes')}
             onClick={() => {trackEvent("PREMIUM-AI", "Tap Click - Personal Wrong Answer Notes", "")}}
            >
              Wrong Answer Notes
            </Link>
            <Link to="/premium/analysis"
             className={"side "+urlCheck(loc, 'analysis')}
             onClick={() => {trackEvent("PREMIUM-AI", "Tap Click - Personal Study Analysis", "")}}
            >
              Study Analysis
            </Link>
          </Col>
        </Row>:
        null
      }
    </div>
  );
};

export default ProNav;



// WEBPACK FOOTER //
// ./src/components/pro.nav.js